import {createEl} from '../createElement'
import {setSceneStatus} from '../utils'
import {complete} from '../complete'
import {loadAudio} from '../audio/playAudio'
import {cueVideoCaptions} from '../captions'
import {createSprite, loadSprites} from '../sprites/playSprite'
import {transition} from '../transition'

function intro() {

  const root = document.getElementById('root')

  // set scene status
  setSceneStatus('intro')

  // create splash screen
  const startScreen = createEl('div', {id: "start-screen"}, root)

  // create text
  /*
  let text = createEl('div', {id: 'text'}, startScreen)
  createEl('p', {innerText: "Make sure your sound is on."}, text)
  let mobileText = createEl('p', {}, text)
  createEl('strong', {innerText: "On a phone or tablet? "}, mobileText)
  createEl('span', {innerText: "Make sure the ringer switch is on, too."}, mobileText)
  */

  // create start button
  const startButton = createSprite('StartButton', startScreen)
  createEl('span', {innerText: "Start"}, startButton)
  startButton.addEventListener('click', () => {
    transition('fadeOut', {
      el: startScreen,
      onEnd: playVideo
    })
    // indicate to parent that we are starting
    window.parent.postMessage('Game started', '*')
    document.addEventListener('touchstart', () => {
      window.parent.postMessage('Game touch', '*')
    })
  })

  // create video
  const gameRoot = createEl('div', {id: 'intro'}, document.getElementById('root') )
  const introVideo = createEl('video', {src: '../media/video/intro.mp4', playsinline: true}, gameRoot)
  introVideo.load()

  const introCaptions = {
    7500: "My Dearest Mrs. Claus, after another triumphant Christmas, I am as giddy as a bowl full of jelly for this much-needed respite.",
    16000: "I can’t wait to kick off my boots, throw back my sash, and bask in the equatorial sun with your trademark Kris Kringle candy canes.",
    26000: "And, with the reindeer off on their annual couples’ retreats, the jetpack you gave me is just perfect for a first-class, solo flight.",
    36000: "And the hum of that engine is jollier than an elf after 3 hot cocoas!",
    41000: "(jetpack starts) Oh ho ho… that’ll put a twinkle in your eye!",
    48000: "And love, while I’m away, please charge the batteries for Rudolph’s nose, and leave food out for…",
    55000: "(jetpack misfires) Oh figgy pudding… what was that?",
    61000: "(jetpack misfires again)",
    65000: "(Santa flies through the air) Wha, whoa, whooaaa!"
  }

  function playVideo() {
    introVideo.addEventListener('play', () => {
      loadAudio()
      loadSprites()
      cueVideoCaptions(introVideo, introCaptions)
    })

    introVideo.addEventListener('ended', () => {
      complete('intro', () => {
        gameRoot.parentNode.removeChild(gameRoot)
      })
    })

    introVideo.play()

  }

}

export {intro}
